import { ObjectMapper } from 'json-object-mapper';
import { Model, OptionModel } from '../model';
import { IModel } from '../IModel';

export class DepartmentModel extends Model implements IModel<DepartmentModel> {
  code: string = '';
  name: string = '';
  description: string = '';
  foreingId: string = '';
  companyId: string = '';
  companyGroupId: string = '';

  static create(input: any): DepartmentModel {
    return ObjectMapper.deserialize<DepartmentModel>(DepartmentModel, input);
  }

  toOption(): OptionModel {
		return { label: `${this['code']} - ${this['name']}`, value: this.id } as OptionModel;
	}
}